import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Tool } from '../../types/tools';
import { TOOLS } from '../../data/tools';
import { ToolCard } from './ToolCard';
import { trackEvent } from '../../utils/analytics';

/** "Explore More DiligenceGPT™ Tools" — all nine other tools, most relevant three first. */
export function RelatedTools({
  tool
}: {
  tool: Tool;
}) {
  const ordered = [...tool.related.map(slug => TOOLS.find(item => item.slug === slug)), ...TOOLS.filter(item => item.slug !== tool.slug && !tool.related.includes(item.slug))].filter((item): item is Tool => Boolean(item) && item?.slug !== tool.slug);
  return <section aria-labelledby="more-tools-heading" className="bg-surface" data-id="element-1087" data-mp="34tpk0rmu2tg9">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-1088" data-mp="34wljwli8rs7c">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-1089" data-mp="3irnw1qdomdsl">
          <h2 id="more-tools-heading" className="sf-display text-[28px] leading-tight text-text-primary sm:text-[36px]" data-id="element-1090" data-mp="3eqc3pd3fbegp">
            Explore More DiligenceGPT™ Tools
          </h2>
          <Link to="/tools" className="inline-flex min-h-[44px] items-center gap-1.5 text-sm font-semibold text-lime hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-1091" data-mp="1ddtuxan1p55i">
            View All Tools
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1092" data-mp="1nbrhltp9atw0" />
          </Link>
        </div>
        <ul className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1093" data-mp="1rbs7qblpwtiw">
          {ordered.map((item, index) => <li key={item.slug} data-id="element-1094" data-mp="1w6ej4ersum2z" data-mpi={index}>
              <ToolCard tool={item} variant="compact" badge={index < 3 ? 'Next step' : undefined} onNavigate={() => trackEvent('related_tool_click', {
            from_tool: tool.slug,
            to_tool: item.slug
          })} data-id="element-1095" data-mp="213xyxj45b6x1" />
            </li>)}
        </ul>
      </div>
    </section>;
}